import { ChangeDetectionStrategy, Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: '[pm-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @Input() pmType: 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'link' = 'primary';
  @Input() fullWidth = false;

  @HostBinding('class.pm-button_primary') get primary() {
    return this.pmType === 'primary';
  }
  @HostBinding('class.pm-button_secondary') get secondary() {
    return this.pmType === 'secondary';
  }
  @HostBinding('class.pm-button_tertiary') get tertiary() {
    return this.pmType === 'tertiary';
  }
  @HostBinding('class.pm-button_ghost') get ghost() {
    return this.pmType === 'ghost';
  }
  @HostBinding('class.pm-button_link') get link() {
    return this.pmType === 'link';
  }
  @HostBinding('class.pm-button_full-width') get width() {
    return this.fullWidth;
  }
}
